import request from '@/utils/request'; // 获取列表

export function fetchManageList(data) {
  return request({
    url: '/pmsservice/api/partyBusinessGuide/list',
    method: 'post',
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/partyBusinessGuide/insert',
    method: 'post',
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/partyBusinessGuide/get',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/pmsservice/api/partyBusinessGuide/delete',
    method: 'post',
    data: data
  });
} // 编辑

export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/partyBusinessGuide/update',
    method: 'post',
    data: data
  });
}
export function fetchClassList(data) {
  return request({
    url: '/pmsservice/api/partyBusinessGuide/update',
    method: 'post',
    data: data
  });
}
export function fetchDetailForManage(data) {
  return request({
    url: '/pmsservice/api/partyBusinessGuide/update',
    method: 'post',
    data: data
  });
}
export function fetchReadList(data) {
  return request({
    url: '/pmsservice/api/partyBusinessGuide/readerList',
    method: 'post',
    data: data
  });
}
export function fetchRelease(data) {
  return request({
    url: '/pmsservice/api/partyBusinessGuide/guidePublish',
    method: 'post',
    data: data
  });
}